export const UserType = [
    { type: "Super Admin", value: 1 },
    { type: "Admin", value: 2 },
    { type: "User", value: 3 },
];

export const issue_type = [
    { 
        issue_type_id: 1, 
        issue_type_name: 'Epic', 
        description: 'A large body of work that can be broken down into smaller tasks (e.g., stories, tasks, or bugs).' 
    },
    { 
        issue_type_id: 2, 
        issue_type_name: 'Story (User Story)', 
        description: 'Represents a feature or functionality from the end-user\'s perspective.' 
    },
    { 
        issue_type_id: 3, 
        issue_type_name: 'Task', 
        description: 'A piece of work that needs to be completed.' 
    },
    { 
        issue_type_id: 4, 
        issue_type_name: 'Bug', 
        description: 'Represents a defect or issue in the software that needs to be fixed.' 
    },
    { 
        issue_type_id: 5, 
        issue_type_name: 'Sub-task', 
        description: 'A smaller, more granular piece of work that is part of a larger issue (e.g., a story or task).' 
    },
    { 
        issue_type_id: 6, 
        issue_type_name: 'Incident', 
        description: 'Used to track unexpected issues or outages in a production environment.' 
    },
    { 
        issue_type_id: 7, 
        issue_type_name: 'Change Request', 
        description: 'Represents a request to modify an existing feature or system.' 
    },
    { 
        issue_type_id: 8, 
        issue_type_name: 'New Feature', 
        description: 'Represents a request for a new functionality or feature to be added to the system.' 
    },
    { 
        issue_type_id: 9, 
        issue_type_name: 'Improvement', 
        description: 'Represents an enhancement or optimization of an existing feature.' 
    },
    { 
        issue_type_id: 10, 
        issue_type_name: 'Technical Debt', 
        description: 'Represents work that needs to be done to address code quality or architectural issues.' 
    },
    { 
        issue_type_id: 11, 
        issue_type_name: 'Test Case', 
        description: 'Represents a specific test scenario to validate functionality.' 
    },
    { 
        issue_type_id: 12, 
        issue_type_name: 'Test Execution', 
        description: 'Represents the execution of a test case and its results.' 
    },
    { 
        issue_type_id: 13, 
        issue_type_name: 'Requirement', 
        description: 'Represents a specific need or condition that must be met by the system.' 
    },
    { 
        issue_type_id: 14, 
        issue_type_name: 'Risk', 
        description: 'Represents a potential issue or threat that could impact the project.' 
    },
    { 
        issue_type_id: 15, 
        issue_type_name: 'Defect', 
        description: 'Similar to a bug, but often used in formal testing processes to track issues found during testing.' 
    },
    { 
        issue_type_id: 16, 
        issue_type_name: 'Spike', 
        description: 'Represents a time-boxed research or investigation task to explore a solution or gather information.' 
    },
    { 
        issue_type_id: 17, 
        issue_type_name: 'Documentation', 
        description: 'Represents work related to creating or updating documentation.' 
    },
    { 
        issue_type_id: 18, 
        issue_type_name: 'Support Ticket', 
        description: 'Represents a request from a user or customer for assistance or resolution of an issue.' 
    },
    { 
        issue_type_id: 19, 
        issue_type_name: 'Backlog Item', 
        description: '' 
    }
  ];
  